export default "__VITE_ASSET__D6NK4d2e__"